import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/notificationSettings/myCompany/companySettings', request)
}

async function put(request) {
    return await putMethod('/api/notificationSettings/myCompany/companySettings', request)
}

export {get, put}
